"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var icons_1 = require("../../../../../icons");
var styled_2 = require("./styled");
var styled_components_1 = require("styled-components");
var themes_1 = require("../../../../themes");
var grey40 = themes_1.colors.grey40;
var Tag = function (_a) {
    var id = _a.id, _b = _a.fill, fill = _b === void 0 ? "solid" : _b, _c = _a.size, size = _c === void 0 ? "S" : _c, display = _a.display, icon = _a.icon, weight = _a.weight, onClick = _a.onClick, variant = _a.variant, typo = _a.typo, badgeColor = _a.badgeColor, style = _a.style;
    var Icon = icons_1.icons[icon];
    var theme = (0, styled_components_1.useTheme)();
    var Typo = typo || styled_2.Styled_UI_CAPTION_DF;
    return (react_1.default.createElement(styled_1.StyledTag, { id: id, fill: fill, size: size, icon: icon, onClick: onClick, variant: variant, colors: theme === null || theme === void 0 ? void 0 : theme.colors, style: style },
        badgeColor && react_1.default.createElement("div", { style: { background: badgeColor, width: "1rem", height: "1rem", borderRadius: "50%", marginRight: "0.2rem" } }),
        react_1.default.createElement(Typo, { weight: weight },
            " ",
            display,
            " "),
        icon &&
            react_1.default.createElement(styled_2.StyledIconWrapper, { weight: weight },
                react_1.default.createElement(Icon, { size: size === "XS" ? 10 : 12, weight: "bold", style: { color: grey40 } }))));
};
exports.Tag = Tag;
